import React, { createContext, useMemo } from 'react';
export var RetilContext = createContext({});
export function Provider(_a) {
    // TODO: memoize on context shallow comparison
    var children = _a.children, resourceCacheModel = _a.resourceCacheModel, context = _a.context, store = _a.store;
    var value = useMemo(function () { return ({
        resourceCacheModel: resourceCacheModel,
        context: context,
        store: store,
    }); }, [resourceCacheModel, context, store]);
    return React.createElement(RetilContext.Provider, { value: value }, children);
}
//# sourceMappingURL=environment.js.map